import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { MusicRecordingStudioFormProps } from "./types";

export class MusicRecordingStudioFormDefinitions extends CmsReactComponent<MusicRecordingStudioFormProps> {
    static defaultProps = {};

    static schemaName = "music-recording-studio-form";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        text: "Başlık",
        mapping: {
            type: PropertyMappingType.String,
        },
    }, {
        name: "description",
        text: "Açıklama",
        mapping: {
            type: PropertyMappingType.Html,
        },
    }];
}
